import { FC } from "react";

import { Box, useMultiStyleConfig } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { TRangeDateLabelProps } from "./types";

const RangeDateLabel: FC<TRangeDateLabelProps> = ({ isEndDate }) => {
  const { t } = useTranslation();
  const styles = useMultiStyleConfig("DatePicker", {});
  const label = isEndDate ? t("common-date_picker-end_date") : t("common-date_picker-start_date");

  return <Box sx={styles.rangeDateLabel}>{label}</Box>;
};
export default RangeDateLabel;
